<template>
    <el-card class="page_card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <el-page-header @back="goBack" :content="mode == 'add'?'添加文章':'编辑文章'"></el-page-header>
        </div>
        <el-row>
            <el-col :lg="16" :md="20" :sm="24">
                <el-form label-width="120px" :model="form" ref="addForm" :rules="rules">
                    <el-form-item label="标题" prop="name">
                        <el-input v-model="form.name" placeholder="请输入文章标题" maxlength="20" show-word-limit></el-input>
                    </el-form-item>
<!--                    <el-form-item label="栏目" prop="catId">-->
<!--                        <el-select v-model="form.catId" placeholder="请选择文章栏目">-->
<!--                            <el-option-->
<!--                                v-for="item in cat_list"-->
<!--                                :key="item.id"-->
<!--                                :label="item.name"-->
<!--                                :value="item.id">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item label="文章摘要" prop="desc">
                        <el-input v-model="form.desc" maxlength="100" show-word-limit type="textarea" placeholder="请输入文章摘要"></el-input>
                    </el-form-item>
                    <el-form-item label="文章内容" prop="content">
                        <tinymce id="art_content" ref="editor" v-model="form.content" :height="500"></tinymce>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button plain type="primary" @click="addSubmit" :loading="is_post" v-if="mode == 'add'">提 交</el-button>
                        <el-button plain type="warning" @click="editSubmit" :loading="is_post" v-if="mode == 'edit'">保 存</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

    </el-card>
</template>

<script>
import tinymce from "./Tinymce/index"
import request from '@/utils/request'
import NodeRequest from "@/utils/node-request"
import {deepClone} from '@/utils'

export default {
    name: 'add_art',
    components:{
        tinymce
    },
    data(){
        return {
            is_ok:false,
            mode:"add",
            data:{},
            is_post:false,
            form:{
                name:"",
                desc:"",
                content:"",
            },
            id:0,
            cat_list:[
                {id:1,name:"气质报告"},
                {id:2,name:"今日资讯"},
            ],
            rules:{
                name:[
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                ],
                desc:[
                    { required: true, message: '请输入文章摘要', trigger: 'blur' },
                ],
                catId:[
                    { required: true, message: '请选择文章栏目', trigger: 'blur' },
                ],
                content:[
                    { required: true, message: '请输入文章内容', trigger: 'blur' },
                ]
            }
        }
    },
    methods:{
        goBack(){
            this.$router.back();
        },
        addSubmit(){
            this.$refs["addForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                NodeRequest.post("article/create",this.form).then(res=>{
                    this.$confirm('是否继续创建文章?', '创建文章成功!', {
                        confirmButtonText: '是',
                        cancelButtonText: '跳转至列表页',
                        type: 'success'
                    }).then(() => {
                        this.$refs["addForm"].resetFields();
                        this.form = {
                            name:"",
                            desc:"",
                            content:""
                        };
                        this.$refs["editor"].setContent("");
                    }).catch(()=>{
                        this.$router.replace({
                            path: '/redirect' + "/article/index"
                        })
                    });
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        editSubmit(){
            this.$refs["addForm"].validate(valid => {
                if (!valid) return false;
                this.is_post = true;
                let data = deepClone(this.form);
                data.id = this.id;
                NodeRequest.post("article/edit",data).then(res=>{
                    this.$confirm('是否继续修改该文章?', '修改文章成功!', {
                        confirmButtonText: '是',
                        cancelButtonText: '跳转至列表页',
                        type: 'success'
                    }).then(() => {

                    }).catch(()=>{
                        this.$router.replace({
                            path: '/redirect' + "/article/index"
                        })
                    });
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        getData(id){
            NodeRequest.get("article/get_one/"+id).then(res=>{
                this.form.name = res.data.name;
                this.form.desc = res.data.desc;
                this.form.content = res.data.content;
                this.id = res.data.id;
                this.$refs["editor"].setContent(res.data.content);
                this.is_ok = true;
            }).catch(err=>{
                this.is_ok = true;
            });
        }
    },
    created() {
        if(this.$route.name == "article_edit" && typeof this.$route.params.id != "undefined" && this.$route.params.id){
            this.mode = "edit";
            this.getData(this.$route.params.id);
        }else{
            this.mode = "add";
            this.is_ok = true;
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
